import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=85e7bf6a&lang=pug"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85e7bf6a')) {
      api.createRecord('85e7bf6a', component.options)
    } else {
      api.reload('85e7bf6a', component.options)
    }
    module.hot.accept("./ContactForm.vue?vue&type=template&id=85e7bf6a&lang=pug", function () {
      api.rerender('85e7bf6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/forms/ContactForm.vue"
export default component.exports